import React, {Component} from "react";

import Dropdown from 'react-bootstrap/Dropdown';
import "./Component.css";


class CustomDropdown extends Component {
    state = {
        dropdownToggleText : "Select Service",
    }

    handleOnSelect = (selectedClient) => {
        this.props.updateSelectedClientId(selectedClient.id, selectedClient.client_name);
        this.setState({dropdownToggleText: selectedClient.client_name});
    }
    
    render() {
        const swaggerRegisteredClients = this.props.swaggerRegisteredClients;
        
        let dropdownItems = [];
        
        if (swaggerRegisteredClients != null) {    
            for(let i = 0; i < swaggerRegisteredClients.length; i++) {
                dropdownItems.push(
                    <Dropdown.Item key={swaggerRegisteredClients[i].id} 
                        onClick={() => this.handleOnSelect(swaggerRegisteredClients[i])}>
                        {swaggerRegisteredClients[i].client_name}
                    </Dropdown.Item>
                );
            }
        }

        return (
            <Dropdown >
           <Dropdown.Toggle variant="flat" id="dropdown-basic">
                    {this.state.dropdownToggleText}
            </Dropdown.Toggle>
    
                <Dropdown.Menu className="dropdown-menu">
                    {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
                    {dropdownItems}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
    
}

export default CustomDropdown;